import React, { useState, useEffect } from 'react';
import { fetchStats } from '../api';

export default function StatsBar({ activeStat, setActiveStat, refreshSignal, onStatsLoad, setView, setActiveFilter }) {
  const STAT_META = {
    'total-kahanis': { icon: '📝', color: '#0ea5e9' },
    'offer-rate':    { icon: '✅', color: '#10b981' },
    'ghost-rate':    { icon: '👻', color: '#f97316' },
    'rejected':      { icon: '❌', color: '#ef4444' },
    'in-progress':   { icon: '⏳', color: '#eab308' },
  };

  const [stats, setStats] = useState([
    { id: 'total-kahanis', value: '0',   label: 'Total Kahanis', action: 'home'        },
    { id: 'offer-rate',    value: '0%',  label: 'Offer Rate',    action: 'offer'       },
    { id: 'ghost-rate',    value: '0%',  label: 'Ghost Rate',    action: 'ghost'       },
    { id: 'rejected',      value: '0%',  label: 'Rejected',      action: 'rejected'    },
    { id: 'in-progress',   value: '0',   label: 'In Progress',   action: 'in-progress' },
  ]);

  useEffect(() => {
    async function loadStats() {
      try {
        const data = await fetchStats();
        const s = data.stats;
        if (onStatsLoad) onStatsLoad(s);
        setStats([
          { id: 'total-kahanis', value: (s.totalReviews ?? 0).toLocaleString(), label: 'Total Kahanis', action: 'home'        },
          { id: 'offer-rate',    value: `${s.offerRate}%`,                       label: 'Offer Rate',   action: 'offer'       },
          { id: 'ghost-rate',    value: `${s.ghostRate}%`,                       label: 'Ghost Rate',   action: 'ghost'       },
          { id: 'rejected',      value: `${s.rejectedRate ?? 0}%`,               label: 'Rejected',     action: 'rejected'    },
          { id: 'in-progress',   value: (s.ongoingCount ?? 0).toLocaleString(),  label: 'In Progress',  action: 'in-progress' },
        ]);
      } catch (err) {
        console.error('Failed to load stats:', err);
      }
    }
    loadStats();
  }, [refreshSignal, onStatsLoad]);

  const handleClick = (s) => {
    if (s.id === 'total-kahanis') {
      setActiveStat(null);
      if (setActiveFilter) setActiveFilter('All');
      if (setView) setView('home');
      return;
    }
    if (activeStat === s.id) {
      setActiveStat(null);
      if (setActiveFilter) setActiveFilter('All');
      if (setView) setView('home');
    } else {
      setActiveStat(s.id);
      if (setActiveFilter) {
        if      (s.id === 'offer-rate')  setActiveFilter('✅ Received');
        else if (s.id === 'ghost-rate')  setActiveFilter('👻 Ghosted');
        else if (s.id === 'rejected')    setActiveFilter('❌ Rejected');
        else if (s.id === 'in-progress') setActiveFilter('⏳ In Progress');
      }
      if (setView) setView('home');
    }
  };

  return (
    <div
      data-tour="stats"
      onClick={(e) => e.stopPropagation()}
      className="stats-bar-inner"
      style={{
        display: 'flex', gap: 1,
        background: 'var(--border)',
        border: '1px solid var(--border)', borderRadius: 10,
        overflow: 'hidden', marginBottom: 20,
        height: 80,
      }}
    >
      {stats.map((s) => {
        const isActive = activeStat ? activeStat === s.id : s.id === 'total-kahanis';
        return (
          <div
            key={s.id}
            onClick={(e) => { e.stopPropagation(); handleClick(s); }}
            style={{
              flex: isActive ? 1.18 : 1,
              minWidth: 0,
              background: isActive ? 'var(--surface2)' : 'var(--surface)',
              transition: 'flex 0.25s ease, background 0.2s ease',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              padding: '0 6px',
              position: 'relative',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 4 }}>
              <div className="stat-value" style={{
                fontFamily: 'var(--sans)',
                fontSize: 18,
                fontWeight: 800,
                lineHeight: 1,
                color: 'var(--text)',
                transition: 'color 0.2s',
              }}>
                {s.value}
              </div>
            </div>
            <div className="stat-label" style={{
              fontSize: 9,
              color: 'var(--text3)',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              transition: 'color 0.2s',
            }}>
              {s.label}
            </div>
            {/* Active indicator bar at bottom */}
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0, height: 3,
              background: STAT_META[s.id].color,
              opacity: isActive ? 1 : 0,
              transition: 'opacity 0.25s ease',
            }} />
          </div>
        );
      })}
    </div>
  );
}
